<template>
    <div class="vue-map-wrapper">
        <div :id="mapId" class="map-wrapper"></div>
    </div>
</template>

<script>
import 'jsvectormap'
import 'jsvectormap/dist/maps/world.js'

export default {
    name: "MapWrapper",

    props: ['countries', 'eventBus', 'selectedCountryCode', 'mappedCountriesWithCodeAndName'],

    data() {
        return {
            map: ""
        }
    },

    computed: {
        mapId() {
            return _.uniqueId('map-');
        },

        countryCodes() {
            return _.map(this.map.regions, (val, key) => {
                return key;
            })
        }
    },

    mounted() {
        this.createMap();

        this.eventBus.$on('resize-map', () => {
            this.updateMapSize();
        });

        this.eventBus.$on('reset-map', () => {
            this.resetMap();
        });

        this.eventBus.$on('reset-focus', () => {
            this.map.clearSelectedRegions();
            this.$emit('selected', '');

            this.map.setFocus({
                regions: this.countryCodes,
                animate: true
            });

            setTimeout(() => {
                this.map.updateSize();
            },600)
        });

        this.eventBus.$on('selected-country-filters', (payload) => this.handleCountryFilters(payload));

        this.eventBus.$on('reset-filters', () => this.removeFilterDataAttributes());
    },

    methods: {
        createMap() {
            this.map = new jsVectorMap({
                selector: `#${this.mapId}`,
                map: 'world',
                series: {
                    regions: [{
                        values: this.countries,
                        scale: {1: "#e4022e"},
                        normalizeFunction: "polynomial"
                    }]
                },

                regionStyle: {
                    initial: {
                        fill: "#ECE8E1",
                        "fill-opacity": 1,
                        stroke: "#ffffff",
                        "stroke-width": 0.1,
                        "stroke-opacity": 1
                    },
                    hover: {
                        fill: "#b80224",
                        "fill-opacity": 1,
                        stroke: "#b80224"
                    },
                    selected: {
                        fill: "#91001d",
                        "fill-opacity": 1,
                        stroke: "#91001d"
                    },
                },
                regionsSelectable: true,
                regionsSelectableOne: true,
                zoomAnimate: true,
                zoomMax: 3,
                zoomOnScroll: false,

                onRegionSelected: (code, isSelected, selectedRegions) => {
                    if (_.isEqual(code, this.selectedCountryCode)) {
                        this.map.clearSelectedRegions();
                        this.eventBus.$emit('close-aside');
                        this.$emit('selected', '');

                        this.map.setFocus({
                            regions: this.countryCodes,
                            animate: true
                        })

                        setTimeout(() => {
                            this.map.updateSize();
                        },600)
                        return;
                    }

                    this.$emit('selected', code);

                    setTimeout(() => {
                        this.map.updateSize();

                        this.map.setFocus({
                            region: code,
                            animate: true
                        });
                    }, 100)
                },

                onRegionTooltipShow: (e, el, code) => {
                    // console.log(e);
                    // console.log(el);
                    // console.log(code);
                },

                onLoaded: (map) => {
                    window.addEventListener('resize', _.debounce(() => {
                        map.updateSize()
                    }, 200))
                }
            });

            _.forEach(this.mappedCountriesWithCodeAndName, (value, key) => {
                this.map.mapData.paths[key].name = value;
            });
        },

        resetMap() {
            this.map = '';
            document.getElementById(`${this.mapId}`).innerHTML = '';

            this.createMap();
        },

        updateMapSize() {
            this.map.updateSize();

            const selectedRegions = this.map.getSelectedRegions();

            if (!_.isEmpty(selectedRegions)) {
                this.map.setFocus({
                    region: selectedRegions[0],
                    animate: false
                });
            }
        },

        removeFilterDataAttributes() {
            const initialPaths = document.querySelectorAll('.vue-map-wrapper .map-wrapper [fill="#e4022e"]');

            initialPaths.forEach((path) => {
                path.removeAttribute('data-active-filter');
            });
        },

        setInitialFilterDataAttributes() {
            const initialPaths = document.querySelectorAll('.vue-map-wrapper .map-wrapper [fill="#e4022e"]');

            initialPaths.forEach((path) => {
                path.setAttribute('data-active-filter', 'inactive');
            });
        },

        handleCountryFilters(payload) {
            if (payload.results === false) {
                this.setInitialFilterDataAttributes();
                return;
            }

            if (_.isEmpty(payload.data)) {
                this.removeFilterDataAttributes();
                return;
            }

            this.setInitialFilterDataAttributes();

            payload.data.forEach((item) => {
                const filteredPath = document.querySelector(`.vue-map-wrapper .map-wrapper [data-code="${item}"]`);

                filteredPath.setAttribute('data-active-filter', 'active');
            });
        }
    }
}
</script>